module.exports = __webpack_public_path__ + "images/dropbox-mark.215858e3544ae873917a.svg";